import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { EMPTY_STRING } from 'lib/core/resources/constants'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CreateCustomerCartMutationObject {
  mutation: {
    createCustomerCart: {
      __args: {
        input: {
          guest_cart_id: string
        }
      }
      cart_id: boolean
    }
  }
}

export const createCustomerCartMutationObject: CreateCustomerCartMutationObject = {
  mutation: {
    createCustomerCart: {
      __args: {
        input: {
          guest_cart_id: ''
        }
      },
      cart_id: true
    }
  }
}

interface CreateCustomerCartMutationInput {
  guestCartId?: string
}

export type CreateCustomerCartMutation = (input: CreateCustomerCartMutationInput) => Promise<FetchResult<any>>

export const createCreateCustomerCartMutation = ({ getMutations }: ServiceDependencies): CreateCustomerCartMutation => async ({ guestCartId }) => {
  const mutation = getMutations().createCustomerCartMutation
  mutation.mutation.createCustomerCart.__args.input.guest_cart_id = guestCartId ?? EMPTY_STRING

  return apolloClient.mutate({
    mutation: gql`${jsonToGraphQLQuery(mutation)}`
  })
}
